import {MatchEventGoalResource} from 'app/components/match/liveResult/updateScorer/sharedTypes';
import {Highlight} from 'app/components/match/liveResult/types';

export default function getHighlightDataFromMatchEvent(matchEvent: MatchEventGoalResource): Highlight {
  return {
    id: matchEvent.entity.id,
    minute: matchEvent.entity.minute,
    additionalMinute: matchEvent.entity.additionalMinute,
    team: {
      slug: matchEvent.entity.team.slug,
    },
    homeGoal: matchEvent.entity.homeGoal,
    awayGoal: matchEvent.entity.awayGoal,
    type: matchEvent.entity.type,
    subtype: matchEvent.entity.subtype,
    primaryRole: matchEvent.entity.primaryRole
      ? {
          player: {
            firstName: matchEvent.entity.primaryRole.player.firstName,
            lastName: matchEvent.entity.primaryRole.player.lastName,
          },
        }
      : null,
    length: 0,
  };
}
